const EDUCATIONS = 'store-educations';
const PERSONAL_DATA = 'store-personal-data';
const REGISTER = 'store-register';
const SKILLS = 'store-skills';
const FILTER_JOB = 'filter-job';
const FILTER_APPLICATION_HISTORY = 'filter-application-history';

export {
    EDUCATIONS,
    PERSONAL_DATA,
    REGISTER,
    SKILLS,
    FILTER_JOB,
    FILTER_APPLICATION_HISTORY,
}